export const CHILD_COMPANY_TABLE = {
  tableColumns: [
    {
      title: 'Profile',
      key: 'profile',
      sortable: false,
      type: 'profile',
      align: 'left',
      width: 350, // Increased width for company name and email
      style: {
        opacity: 'opacity-100'
      }
    },
    {
      title: 'Contract End Date',
      key: 'contract_end_date',
      type: 'date',
      sortable: true,
      align: 'left',
      width: 150
    },
    {
      title: 'Cost Per Seat',
      key: 'seat_price',
      type: 'number',
      align: 'center',
      width: 120
    },
    {
      title: 'Subscription',
      key: 'company_subscription',
      sortable: false,
      sortKey: 'company_subscription',
      type: 'accountType',
      align: 'left',
      width: 130
    },
    {
      title: 'Contract Signed',
      key: 'contract_signed',
      sortable: false,
      type: 'boolean',
      align: 'center',
      width: 130
    }
  ]
};
